import ReactDOM from "react-dom/client";
import "./styles/index.css";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./components/errorPage/ErrorPage.jsx";
import * as Sentry from "@sentry/react";
import App from "./App/App.jsx";

Sentry.init({
    dsn: "https://a336f3e72ff070edc48e514f1a17ec64@o4508525848887296.ingest.de.sentry.io/4508525860618320",
    integrations: [
        Sentry.feedbackIntegration({
            // Additional SDK configuration goes in here, for example:
            colorScheme: "system",
            isNameRequired: true,
            isEmailRequired: true,
            showBranding: false,
            // autoInject: false,
            buttonLabel: "ابلغ عن المشكلة",
            formTitle: "ابلغ عن المشكلة",
            submitButtonLabel: "ارسال",
            cancelButtonLabel: "الغاء",
            nameLabel: "الأسم",
            namePlaceholder: "الأسم",
            emailLabel: "الإيميل",
            emailPlaceholder: "الإيميل",
            messageLabel: "الوصف",
            messagePlaceholder: "ما هي المشكله التي تواجهك بالتفاصيل",
            successMessageText: "شكرا لك سنحل المشكله في اقرب وقت",
            isRequiredText: "إجباري",
        }),
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/mrsherif-osama\.com\.io\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById("root")).render(
    <ErrorBoundary
        FallbackComponent={ErrorPage}
        onReset={() => window.location.replace("/")}
    >
        <App />
    </ErrorBoundary>
);
